import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {requestPermission} from '../push-notifications'
//import { onUserLogin } from '../utils/serviceWorkerUtils';
import { updateUserInServiceWorker } from '../utils/serviceWorkerUtils';

function OTP() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState({});
  const [otp, setOtp] = useState(['', '', '', '']); // Changed to 4 digits
  const [message, setMessage] = useState('');
  const [timer, setTimer] = useState(60);
  const inputRefs = useRef([]);
  const verifyOTP = process.env.REACT_APP_FORE_APILINK + '/user/verify-otp-and-login';
  const Login = process.env.REACT_APP_FORE_APILINK + '/user/visitor-admin-login';

  const { mobileNumber } = location.state;
  
  useEffect(() => {
    const storedData = localStorage.getItem('userData');
    if (storedData) {
      setUserData(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleChange = (index, value) => {
  if (/^\d*$/.test(value)) {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    
    if (value !== '' && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  
    if (value !== '' && index === 3) {
      inputRefs.current[index].blur();
    }
  }
};


  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleOTP = async () => {
    if (mobileNumber.length === 10) {
      try {
        const res = await fetch(Login, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ mobile_number: mobileNumber }),
        });
        
        if (res.ok) {
          setTimer(60);
        } else {
          console.error('Login failed');
          setMessage("Try with valid number");
        }
      } catch (error) {
        console.error('Error:', error);
        clearStorageAndRedirectToHome();
      }
    }
  };

  function clearStorageAndRedirectToHome() {
    navigate("/visitor");
  }
  
  const handleVerifyOtp = async () => {
    const otpString = otp.join('');

    try {
      const response = await fetch(verifyOTP, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobile_number: mobileNumber,
          otp: otpString,
        }),
      });

      const data = await response.json();
      console.log("data:",data)
      if (response.ok) {
        localStorage.setItem('userData', JSON.stringify(data));
        sessionStorage.setItem('userData', JSON.stringify(data));
        sessionStorage.setItem('userId', data._id);
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('roleId', data.roleId);
        localStorage.setItem('userId', data._id);

        requestPermission()
        const userId = data._id;
        // Notify service worker about the user login
        updateUserInServiceWorker(userId);
          navigate("/visitors");

        setMessage(data.message);
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage('Internal server error.');
    }
  };

  return (
    <div className="w-full flex justify-center items-center h-screen bg-white">
      <div className="w-full max-w-md px-6 py-0">
        {/* Logo and welcome text - reduced margin bottom */}
        {/* <div className="flex flex-col items-center mb-8">
          <img src={'/BB.png'} alt="Logo" className="h-20 w-30 mb-3" />
        </div> */}
        
        <div className="bg-white rounded-lg shadow-sm border border-[#C20C0C] overflow-hidden min-h-[400px] flex flex-col">
  <div className="px-4 py-6">
    <h3 className="text-xl font-semibold text-[#000000]">Enter Verification Code</h3>
    <p className="text-md text-[#00000] mt-4">
      We have sent a 4-digit code to <span className="font-bold text-md">+91 {mobileNumber}</span>
    </p>
  </div>
  
  <div className="px-4 pt-0.2 pb-6 flex-grow flex flex-col">
    {/* OTP header and input boxes moved to the top */}
    <h3 className="text-lg text-[#00000] mb-2">OTP Code</h3>
    
    <div className="flex justify-start items-start mb-6 ">
      {otp.map((value, index) => (
        <div key={index} className="flex items-center">
          <input
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength="1"
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className="w-12 h-16 text-center text-xl font-semibold border border-[#C20C0C] rounded-md focus:border-[#D93025] focus:ring-0 focus:ring-[#D93025] focus:outline-none"
          />
          {/* Add hyphen between boxes, but not after the last one */}
          {index < otp.length - 1 && (
            <span className="mx-3 text-gray-400 text-xl">-</span>
          )}
        </div>
      ))}
    </div>
    
    {/* Verify button */}
    <button
      className="w-full bg-[#F84C5C] text-white py-3 px-4 rounded-md text-md  font-semibold hover:bg-[#D93025] transition duration-200 focus:outline-none focus:ring-2 focus:ring-[#D93025] focus:ring-opacity-50 mb-4"
      onClick={handleVerifyOtp}
    >
      Verify OTP
    </button>
    
    
    {/* Resend OTP option with improved timer handling */}
    <div className="text-center">
      {timer > 0 ? (
        <p className="text-sm text-[#827E7E] font-semibold">
          Didn't receive code? Resend in <span className="text-[#D93025] font-medium">{timer} seconds</span>
        </p>
      ) : (
        <p className="text-sm text-[#827E7E] font-semibold">
          Didn't receive code? <button className="text-[#3E1EDD] font-semibold" onClick={handleOTP}>Resend OTP</button>
        </p>
      )}
    </div>
    
    {/* Display message if any */}
   
  </div>
</div>

        </div>
      </div>
  
  );
  
}

export default OTP;
